var w = Object.defineProperty;
var x = (a, s, t) => s in a ? w(a, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[s] = t;
var l = (a, s, t) => (x(a, typeof s != "symbol" ? s + "" : s, t), t);
import { tabbable as f } from "tabbable";
let E = 0;
function A() {
  return E++, `c-id-${E}`;
}
function c(a, s) {
  const t = f(a, { displayCheck: "none" });
  return t.length === 0 ? !1 : (t[0].focus(), s && s.scrollTo(0, 0), !0);
}
function g(a) {
  const s = f(a, { displayCheck: "none" });
  return s.length === 0 ? !1 : (s[s.length - 1].focus(), !0);
}
function y(a, s) {
  const t = document.activeElement;
  if (!t || !a)
    return c(a);
  const e = t.parentElement, i = Array.from(a.querySelectorAll(":scope > *")), r = i.findIndex((n) => e === n);
  if (r === -1 || s === "next" && r === i.length - 1)
    return c(a);
  if (s === "previous" && r === 0)
    return g(a);
  for (let n = s === "next" ? r + 1 : r - 1; s === "next" ? n < i.length : n >= 0; s === "next" ? n++ : n--) {
    const h = i[n];
    if (c(h))
      return;
  }
  return s === "next" ? c(a) : g(a);
}
function S(a, s) {
  const t = Array.from(a.querySelectorAll(":scope > *"));
  for (let e = 0; e < t.length; e++) {
    const i = t[e], r = f(i, { displayCheck: "none" }), n = r.length ? r[0] : null;
    if (n && n.textContent && n.textContent.trim().toLowerCase()[0] === s) {
      n.focus();
      return;
    }
  }
}
class L extends Error {
  constructor(s, t = {}, e) {
    super(s, t), this.name = e ? `[c-${e}]` : "[compotes]";
  }
}
class b {
  constructor(s, t = {}) {
    l(this, "name", "");
    l(this, "el");
    l(this, "opts");
    l(this, "events", []);
    const e = typeof s == "string" ? document.querySelector(s) : s;
    if (!e)
      throw this.error("The element/selector provided cannot be found.");
    this.el = e, this.opts = t;
  }
  get isInitializable() {
    return typeof this.opts.init > "u" || this.opts.init === !0;
  }
  get accessibilityStatus() {
    if (typeof this.opts.initAccessibility == "object")
      return {
        attrs: typeof this.opts.initAccessibility.attrs > "u" || this.opts.initAccessibility.attrs === !0,
        events: typeof this.opts.initAccessibility.events > "u" || this.opts.initAccessibility.events === !0,
        styles: typeof this.opts.initAccessibility.styles > "u" || this.opts.initAccessibility.styles === !0
      };
    {
      const s = typeof this.opts.initAccessibility > "u" || this.opts.initAccessibility === !0;
      return {
        attrs: s,
        events: s,
        styles: s
      };
    }
  }
  /**
   * Emit an event
   */
  emitEvent(s, t = !1) {
    const e = new CustomEvent(
      `c.${this.name}.${s}`,
      {
        detail: this,
        cancelable: t
      }
    );
    return this.el.dispatchEvent(e);
  }
  /**
   * Init the component
   */
  init() {
    this.emitEvent("init"), this.accessibilityStatus.styles && this.el.classList.add(`c-${this.name}--a11y`), this.accessibilityStatus.attrs && this.initAccessibilityAttrs(), (typeof this.opts.initEvents > "u" || this.opts.initEvents) && this.initEvents();
  }
  /**
   * Register an event
   */
  registerEvent(s) {
    s.el.addEventListener(s.event, s.function), this.events.push(s);
  }
  /**
   * Destroy the events on the component
   */
  destroyEvents(s = []) {
    const t = s.length ? this.events.filter((e) => s.includes(e.id)) : this.events;
    t.forEach((e) => {
      e.el.removeEventListener(e.event, e.function);
    }), this.events = this.events.filter((e) => !t.includes(e));
  }
  /**
   * Destroy the component
   */
  destroy() {
    this.emitEvent("destroy"), this.destroyEvents();
  }
  /**
   * Options of the component
   */
  get options() {
    return this.opts;
  }
  /**
   * Generate an error message
   * Can be use with `throw` or directly inside `console.error(`)`
   */
  error(s, t) {
    return new L(s, t, this.name);
  }
}
function v(a) {
  let { transitionDuration: s, transitionDelay: t } = window.getComputedStyle(a);
  const e = Number.parseFloat(s), i = Number.parseFloat(t);
  return !e && !i ? 0 : (s = s.split(",")[0], t = t.split(",")[0], (Number.parseFloat(s) + Number.parseFloat(t)) * 1e3);
}
class D extends b {
  constructor(t, e = {}) {
    super(t, e);
    l(this, "currentEl", null);
    l(this, "wrapper", null);
    l(this, "items", []);
    l(this, "level", 0);
    l(this, "resizeObserver");
    l(this, "mutationObserver");
    this.isInitializable && this.init();
  }
  init() {
    if (this.name = "drilldown", this.currentEl = this.el.querySelector(".c-drilldown-menu"), !this.currentEl)
      throw this.error(
        'The component needs to have an ul element : <nav class="c-drilldown"><ul class="c-drilldown-menu"></ul></nav>',
        { cause: this.el }
      );
    this.wrapper = this.currentEl, this.mutationObserver = new MutationObserver(() => {
      this.update(!0);
    }), this.resizeObserver = new ResizeObserver(() => {
      this.updateHeight();
    }), this.resizeObserver.observe(this.el), this.mutationObserver.observe(this.el, {
      childList: !0,
      subtree: !0
    }), super.init(), this.accessibilityStatus.events && this.initAccessibilityEvents(), this.update(!0);
  }
  initAccessibilityAttrs() {
    var r, n, h, u;
    (r = this.wrapper) == null || r.setAttribute("role", "menubar"), (n = this.wrapper) == null || n.setAttribute("aria-multiselectable", "false"), (h = this.wrapper) == null || h.setAttribute("aria-orientation", "vertical"), (u = this.wrapper) == null || u.querySelectorAll(".c-drilldown-menu").forEach((o) => {
      o.setAttribute("role", "menu");
    }), this.el.querySelectorAll(".c-drilldown-menu > li").forEach((o) => {
      o.setAttribute("role", "none");
    });
    const e = this.el.querySelectorAll(".c-drilldown-back"), i = this.el.querySelectorAll(".c-drilldown-next");
    e.forEach((o) => {
      o.setAttribute("role", "menuitem");
    }), i.forEach((o) => {
      var d;
      if (o.setAttribute("role", "menuitem"), o.setAttribute("aria-expanded", "false"), !o.getAttribute("aria-controls")) {
        const p = (d = o.parentElement) == null ? void 0 : d.querySelector(".c-drilldown-menu"), m = (p == null ? void 0 : p.id) || A();
        o.setAttribute("aria-controls", m), p == null || p.setAttribute("id", m);
      }
    });
  }
  // Inspired by https://www.w3.org/WAI/ARIA/apg/patterns/menu/
  initAccessibilityEvents() {
    this.destroyEvents(["key"]), this.registerEvent({
      id: "key",
      event: "keydown",
      el: this.el,
      function: (t) => {
        switch (t.key) {
          case "ArrowUp":
          case "Up":
            this.currentEl && y(this.currentEl, "previous");
            break;
          case "ArrowDown":
          case "Down":
            this.currentEl && y(this.currentEl, "next");
            break;
          case "ArrowLeft":
          case "Left":
          case "Esc":
          case "Escape":
            this.back();
            break;
          case "ArrowRight":
          case "Right": {
            const e = document.activeElement;
            e && e.classList.contains("c-drilldown-next") && this.next(e);
            break;
          }
          case "Home":
          case "PageUp":
            this.currentEl && c(this.currentEl, this.el);
            break;
          case "End":
          case "PageDown":
            this.currentEl && g(this.currentEl);
            break;
          default:
            this.currentEl && S(this.currentEl, t.key);
            break;
        }
      }
    });
  }
  initEvents() {
    const t = this.el.querySelectorAll(".c-drilldown-back"), e = this.el.querySelectorAll(".c-drilldown-next");
    this.destroyEvents(["back", "next"]), t.forEach((i) => {
      this.registerEvent({
        id: "back",
        el: i,
        event: "click",
        function: this.back.bind(this)
      });
    }), e.forEach((i) => {
      this.registerEvent({
        id: "next",
        el: i,
        event: "click",
        function: this.next.bind(this)
      });
    });
  }
  /**
   * Update the drilldown component
   */
  update(t = !1) {
    if (!this.wrapper)
      return;
    this.wrapper.style.transform = `translateX(-${this.level * 100}%)`;
    const e = v(this.wrapper);
    if (this.wrapper.style.setProperty("--c-drilldown-delay", `${e}ms`), this.disableFocusElements(), t) {
      this.updateItems(this.wrapper), this.updateHeight(), this.accessibilityStatus.attrs === !0 && this.initAccessibilityAttrs();
      return;
    }
    this.opts.dynamicHeight === !0 && this.updateHeight(), this.emitEvent("update");
  }
  updateItems(t, e = 0) {
    const i = t.children;
    for (let r = 0; r < i.length; r++) {
      const h = i[r].querySelector(".c-drilldown-menu");
      h && this.updateItems(h, e + 1);
    }
    this.items.push({
      el: t,
      level: e
    });
  }
  updateHeight() {
    let t = 0;
    if (this.opts.dynamicHeight === !0 && this.currentEl)
      t = this.currentEl.clientHeight;
    else
      for (let e = 0; e < this.items.length; e++) {
        const i = this.items[e];
        i.el.clientHeight > t && (t = i.el.clientHeight);
      }
    this.el.style.height = `${t}px`;
  }
  /**
   * Get Next or Back button with click event
   */
  getButton(t, e) {
    let i = null;
    if ("target" in t) {
      const r = t.target;
      i = r.classList.contains(`c-drilldown-${e}`) ? r : r.closest(`.c-drilldown-${e}`);
    } else
      i = t;
    return i;
  }
  disableFocusElements() {
    if (this.el.querySelectorAll("[data-c-hidden]").forEach((i) => {
      i.removeAttribute("data-c-hidden"), i.removeAttribute("tabindex");
    }), !this.currentEl)
      return;
    f(this.el).forEach((i) => {
      i.closest(".c-drilldown-menu") !== this.currentEl && (i.setAttribute("data-c-hidden", "true"), i.setAttribute("tabindex", "-1"));
    });
  }
  /**
   * Go to the next panel
   *
   * @param {(HTMLButtonElement | Event)} button
   */
  next(t) {
    var i;
    const e = this.getButton(t, "next");
    e && (e.setAttribute("aria-expanded", "true"), this.level++, this.currentEl = (i = e.parentElement) == null ? void 0 : i.querySelector(".c-drilldown-menu"), this.update(), this.currentEl && c(this.currentEl, this.el), this.emitEvent("next"));
  }
  /**
   * Back to one level
   */
  back() {
    if (!this.wrapper || this.level === 0)
      return;
    const t = this.wrapper.querySelectorAll('.c-drilldown-next[aria-expanded="true"]'), e = t.length ? t[t.length - 1] : null;
    e && (e.setAttribute("aria-expanded", "false"), this.level--, this.currentEl = e.closest(".c-drilldown-menu"), this.update(), this.currentEl && c(this.currentEl, this.el), this.emitEvent("back"));
  }
  /**
   * Reset the drilldown to the root level
   */
  reset() {
    if (!this.wrapper || this.level === 0)
      return;
    this.wrapper.querySelectorAll('.c-drilldown-next[aria-expanded="true"]').forEach((e) => {
      e.setAttribute("aria-expanded", "false");
    }), this.currentEl = this.wrapper, this.level = 0, this.update(), this.currentEl && c(this.currentEl, this.el), this.emitEvent("reset");
  }
  destroy() {
    var t, e;
    (t = this.mutationObserver) == null || t.disconnect(), (e = this.resizeObserver) == null || e.disconnect(), super.destroy();
  }
}
class z extends b {
  constructor(t, e = {}) {
    super(t, e);
    l(this, "triggers", []);
    l(this, "expanded", !1);
    l(this, "collapsing", !1);
    l(this, "timeout");
    this.isInitializable && this.init();
  }
  init() {
    this.name = "collapse", this.expanded = this.el.classList.contains("c-collapse--show"), this.update(), super.init();
  }
  initAccessibilityAttrs() {
    this.triggers.forEach((t) => {
      t.tagName !== "BUTTON" && t.setAttribute("role", "button");
    });
  }
  initEvents() {
    this.destroyEvents(), this.triggers.forEach((t) => {
      this.registerEvent({
        id: "toggle",
        function: this.toggle.bind(this),
        event: "click",
        el: t
      });
    });
  }
  /**
   * Update trigger status
   */
  update() {
    this.triggers = Array.from(
      document.querySelectorAll(`.c-collapse-trigger[aria-controls="${this.el.id}"]`)
    ), this.triggers.forEach((t) => {
      t.setAttribute(
        "aria-expanded",
        this.expanded ? "true" : "false"
      );
    }), this.emitEvent("update");
  }
  /**
   * Toggle collapse
   */
  toggle() {
    this.expanded ? this.hide() : this.show();
  }
  /**
   * Show collapse
   */
  show() {
    if (this.expanded = !0, this.hasTransition) {
      this.collapsing = !0, this.el.classList.add("c-collapse--collapsing");
      const t = this.el.scrollHeight;
      this.el.style.height = `${t}px`, this.onCollapse();
    } else
      this.emitEvent("shown");
    this.el.classList.add("c-collapse--show"), this.update();
  }
  /**
   * Hide collapse
   */
  hide() {
    if (this.expanded = !1, this.hasTransition) {
      const t = this.el.scrollHeight;
      this.el.style.height = `${t}px`, this.el.offsetHeight, this.collapsing = !0, this.el.classList.add("c-collapse--collapsing"), this.el.style.height = "0px", this.onCollapse();
    } else
      this.emitEvent("hidden");
    this.el.classList.remove("c-collapse--show"), this.update();
  }
  onCollapse() {
    clearTimeout(this.timeout), this.emitEvent(this.expanded ? "show" : "hide"), this.timeout = window.setTimeout(() => {
      this.el.classList.remove("c-collapse--collapsing"), this.collapsing = !1, this.el.style.height = "", this.emitEvent(this.expanded ? "shown" : "hidden");
    }, v(this.el));
  }
  /**
   * Return the status of the collapse
   */
  get isExpanded() {
    return this.expanded;
  }
  /**
   * Return if the collapse is collapsing
   */
  get isCollapsing() {
    return this.collapsing;
  }
  get hasTransition() {
    return v(this.el) !== 0;
  }
}
class O extends b {
  constructor(t, e = {}) {
    super(t, e);
    l(this, "isDown", !1);
    l(this, "draggableClass", "c-drag--draggable");
    l(this, "draggingClass", "c-drag--dragging");
    l(this, "startX", 0);
    l(this, "startY", 0);
    l(this, "scrollLeft", 0);
    l(this, "scrollTop", 0);
    l(this, "hasMoved", !1);
    l(this, "resizeObserver");
    this.isInitializable && this.init();
  }
  init() {
    this.name = "drag", super.init(), this.resizeObserver = new ResizeObserver(() => {
      this.el.classList.toggle(this.draggableClass, this.isDraggable);
    }), this.resizeObserver.observe(this.el);
  }
  initAccessibilityAttrs() {
  }
  initEvents() {
    this.destroyEvents(), ["mouseleave", "mouseup"].forEach((e) => {
      this.registerEvent({
        id: "handleDragEnd",
        function: this.handleDragEnd.bind(this),
        event: e,
        el: this.el
      });
    }), this.registerEvent({
      id: "handleDragMove",
      function: this.handleDragMove.bind(this),
      event: "mousemove",
      el: this.el
    }), this.registerEvent({
      id: "handleDragStart",
      function: this.handleDragStart.bind(this),
      event: "mousedown",
      el: this.el
    }), this.registerEvent({
      id: "handleClick",
      function: this.blockClick.bind(this),
      event: "click",
      el: this.el
    });
  }
  blockClick(t) {
    this.hasMoved && (t.preventDefault(), this.hasMoved = !1);
  }
  handleDragStart(t) {
    this.isDraggable && (this.isDown = !0, this.el.classList.add(this.draggingClass), this.startX = t.pageX - this.el.offsetLeft, this.startY = t.pageY - this.el.offsetTop, this.scrollLeft = this.el.scrollLeft, this.scrollTop = this.el.scrollTop, this.emitEvent("start"));
  }
  handleDragEnd() {
    this.isDown = !1, this.el.classList.remove(this.draggingClass), this.emitEvent("end");
  }
  handleDragMove(t) {
    if (!this.isDown)
      return;
    t.preventDefault();
    const e = t.pageX - this.el.offsetLeft - this.startX, i = t.pageY - this.el.offsetTop - this.startY, r = this.scrollLeft - e, n = this.scrollTop - i;
    (this.el.scrollLeft !== r || this.el.scrollTop !== n) && (this.hasMoved = !0), this.el.scrollLeft = r, this.el.scrollTop = n;
  }
  /**
   * Tell if the element is draggable or not
   */
  get isDraggable() {
    return this.el.clientHeight !== this.el.scrollHeight || this.el.clientWidth !== this.el.scrollWidth;
  }
  /**
   * Tell if the element is dragging
   */
  get isDragging() {
    return this.isDown;
  }
  destroy() {
    var t;
    (t = this.resizeObserver) == null || t.disconnect(), super.destroy();
  }
}
class C extends b {
  constructor(t, e = {}) {
    super(t, e);
    l(this, "containerEl", null);
    l(this, "resizeObserver");
    l(this, "mutationObserver");
    l(this, "clones", []);
    l(this, "fillMultiplier", 1);
    this.isInitializable && this.init();
  }
  init() {
    this.name = "marquee", super.init(), this.update(), this.containerEl = this.el.querySelector(".c-marquee-container"), this.mutationObserver = new MutationObserver(([t]) => {
      Array.from(t.addedNodes).findIndex((r) => r.classList.contains("c-marquee-clone")) === -1 || this.update(this.opts.fill);
    }), this.resizeObserver = new ResizeObserver(() => {
      setTimeout(() => this.update(), 1);
    }), this.resizeObserver.observe(this.el), this.mutationObserver.observe(this.el, {
      childList: !0,
      subtree: !0
    });
  }
  initAccessibilityAttrs() {
    this.el.setAttribute("tabindex", "0");
  }
  initEvents() {
    this.destroyEvents(), this.registerEvent({
      id: "registerLoopEvent",
      function: () => {
        this.emitEvent("loop");
      },
      event: "animationiteration",
      el: this.el
    }), this.accessibilityStatus.events && (this.registerEvent({
      id: "addKeyboardClass",
      function: () => {
        this.el.classList.add("c-marquee--keyboard");
      },
      event: "keydown",
      el: this.el
    }), this.registerEvent({
      id: "removeKeyboardClass",
      function: (t) => {
        const e = t.target;
        e.classList.contains(".c-marquee") || e.closest(".c-marquee") || this.el.classList.remove("c-marquee--keyboard");
      },
      event: "focusout",
      el: this.el
    }));
  }
  get elSize() {
    return this.opts.direction === "up" || this.opts.direction === "down" ? this.el.clientHeight : this.el.clientWidth;
  }
  get containerSize() {
    return this.containerEl ? this.opts.direction === "up" || this.opts.direction === "down" ? this.containerEl.clientHeight / (this.fillMultiplier + 1) : this.containerEl.clientWidth / (this.fillMultiplier + 1) : 0;
  }
  /**
   * Update the marquee
   */
  update(t = !1) {
    var h, u, o;
    if (!this.containerEl)
      return;
    const e = this.opts.direction || "right", i = ["left", "right", "top", "bottom"], r = this.opts.fill ? Math.ceil(this.elSize / this.containerSize) : 1;
    let n;
    if (typeof this.opts.duration == "string")
      n = this.opts.duration;
    else {
      const d = this.opts.fill ? this.containerSize / this.elSize * 0.05 : 0.05;
      n = `${((this.opts.duration || 1) * d * Math.max(this.containerSize, this.elSize)).toFixed(2)}s`;
    }
    this.el.style.setProperty(
      "--c-marquee-duration",
      n
    ), this.el.classList.toggle(
      "c-marquee--fill",
      ((h = this.opts) == null ? void 0 : h.fill) === !0
    ), this.opts.fill && (r && this.fillMultiplier !== r || t) && (this.fill(r), this.fillMultiplier = r), this.el.classList.toggle(
      "c-marquee--behavior-alternate",
      ((u = this.opts) == null ? void 0 : u.behavior) === "alternate"
    ), this.el.classList.toggle(
      "c-marquee--behavior-scroll",
      ((o = this.opts) == null ? void 0 : o.behavior) !== "alternate"
    ), this.el.classList.add(`c-marquee--direction-${e}`), i.forEach((d) => {
      e !== d && this.el.classList.remove(`c-marquee--direction-${d}`);
    }), this.opts.fill ? (this.el.style.setProperty(
      "--c-marquee-start",
      "0"
    ), this.el.style.setProperty(
      "--c-marquee-end",
      `-${Math.ceil(this.containerSize)}px`
    )) : this.el.style.setProperty(
      "--c-marquee-end",
      `${Math.ceil(this.elSize)}px`
    );
  }
  play() {
    this.el.classList.remove("c-marquee--pause"), this.emitEvent("play");
  }
  pause() {
    this.el.classList.add("c-marquee--pause"), this.emitEvent("pause");
  }
  destroy() {
    var t, e;
    (t = this.mutationObserver) == null || t.disconnect(), (e = this.resizeObserver) == null || e.disconnect(), super.destroy();
  }
  fill(t) {
    if (!this.containerEl)
      return;
    this.clones.forEach((i) => i.remove());
    const e = Array.from(this.containerEl.children);
    this.clones = [];
    for (let i = 0; i < t; i++)
      e.forEach((r) => {
        var h;
        const n = r.cloneNode(!0);
        n.classList.add("c-marquee-clone"), this.accessibilityStatus.attrs && n.setAttribute("aria-hidden", "true"), this.clones.push(n), (h = this.containerEl) == null || h.append(n), this.accessibilityStatus.attrs && f(n).forEach((o) => o.setAttribute("tabindex", "-1"));
      });
  }
}
export {
  z as Collapse,
  O as Drag,
  D as Drilldown,
  C as Marquee
};
